import {css} from "styled-components";

export const ReadOnlyStyle = css`
  .ant-custom-readonly {
    min-height: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;  /* Important */
    cursor: text;

    &.wrap-text {
      white-space: normal;
    }

    .placeholder {
      color: rgba(0,0,0,20%);
    }
    
    .ant-checkbox, .ant-checkbox-input {
      cursor: default !important;
    }
    
    &.ant-select-multiple {
      padding: 1px;
    }
    
    &.ant-empty {
      padding: 8px 0;
      margin: 0;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
    }
    
    &.ant-radio-group {
      .ant-radio-button-wrapper {
        cursor: text;
      }
    }

    &.ant-switch {
      min-height: initial;
      cursor: default !important;
      opacity: initial;

      .ant-switch-inner {
        cursor: default !important;
      }
    }

    &.ant-checkbox-wrapper {
      min-height: initial;
    }
  }
`;
